/* @ngInject */
export default function InPersonEventLectureComponentModel(
  $translate,
  LectureComponentBaseModel,
  config,
  _,
) {
  class InPersonEventLectureComponent extends LectureComponentBaseModel {
    constructor(attributes) {
      const defaults = {
        canBeCopied: true,
        type: 'InPersonEventLectureComponent',
        isActivity: true,
        inPersonEvent: {
          title: $translate.instant('LECTURE_PAGES.COMPONENTS.IN_PERSON_EVENTS.DEFAULT_TITLE'),
        },
      };

      super({ ...defaults, ...attributes });
    }

    getPayload() {
      return {
        index: this.index,
        inPersonEvent: _.pick(this.inPersonEvent, [
          'id', 'title', 'eventTitle', 'description', 'startTime', 'endTime', 'timeZone', 'location', 'isTodo', 'mainDescription',
        ]),
      };
    }

    toggleToDo() {
      this.inPersonEvent.isTodo = !this.inPersonEvent.isTodo;
      this.save();
    }

    get deadline() {
      return this.inPersonEvent.deadline;
    }
  }

  InPersonEventLectureComponent.iconClass = 'icon-work';
  InPersonEventLectureComponent.descriptionKey = 'LECTURE_PAGES.COMPONENTS.IN_PERSON_EVENTS.DESCRIPTION';
  InPersonEventLectureComponent.type = 'InPersonEventLectureComponent';
  InPersonEventLectureComponent.pendoTagName = config.pendo.lectureEdit.inPersonEvent;

  return InPersonEventLectureComponent;
}
